module.exports = __webpack_public_path__ + "media/stylesheets/images/staff/staff2-779f4ce159d5570a113fb8b646b9f417.jpg";